<template>
    <div class="m15 page_logo" ref="body" style="page-break-before: always;" v-if="projetos.length" id="projeto">
        <div class="site"></div>

        <h4 class="simulator-title loaded" v-if="exibe === true">Projetos Futuros</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao" />
        <div class="row" v-if="exibe === true">
            <div class="col l12 s12">
                <div class="texto" style="text-align:justify">
                    <template v-if="projetos.length <= 1">
                    Você informou que possui um <b style="font-weight:bold;">projeto futuro</b>, cujo o objetivo é
                    concretizá-lo em {{ projetos[0].tempo_necessario}} ano(s), que exige o seguinte esforço financeiro:
                    </template>
                    <template v-else>
                        Você informou que possui <b style="font-weight:bold;">projetos futuros</b>, que exigem os seguintes esforços financeiro:
                    </template>
                </div>
            </div>
        </div>
        <div class="row" v-if="exibe === true">
            <div class="col l3 x15"></div>
            <div class="col l6 s12 x70">
                <table class="print-table striped">
                    <thead>
                        <tr class='print-table-text-center'>
                            <th>PROJETO</th>
                            <th>VALOR ESTIMADO DO PROJETO</th>
                            <th>VALOR PRESENTE JÁ CAPITALIZADO</th>
                            <th>PRAZO DO PROJETO</th>
                            <th>RENTABILIDADE ANUAL ESTIMADA</th>
                            <th>VALOR DE APORTE MENSAL NECESSÁRIO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="print-table-text-center" v-for="projeto in projetos" :key="`projeto-${projeto.projeto_id}`">
                            <td data-label="NOME">{{ projeto.nome }}</td>
                            <td data-label="VALOR ESTIMADO DO PROJETO">{{ projeto.valor_necessario | dinheiro }}</td>
                            <td data-label="VALOR PRESENTE JÁ CAPITALIZADO">{{ projeto.valor_reserva | dinheiro }}</td>
                            <td data-label="PRAZO DO PROJETO">{{ projeto.tempo_necessario || 0 }} ano(s)</td>
                            <td data-label="RENTABILIDADE ANUAL ESTIMADA">{{ projeto.rentabilidade_estimada }}%</td>
                            <td data-label="VALOR DE APORTE MENSAL NECESSÁRIO">{{projeto.necessidade_investimento | dinheiro }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col l3 x15"></div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                <div class="texto">
                    Uma outra alternativa para a realização do seu projeto de curto ou médio prazo é a
                    aquisição de uma cota de consórcio, que nada mais é do que uma ferramenta de
                    compra programada, porém lhe permite a antecipação da realização do sonho, do
                    projeto, via a oferta de lances ou mesmo a contemplação via sorteio.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import Saudacao from './Saudacao'
    export default {
        name: 'ProjetosFuturos',

        props: {
            cliente: {
                type: Object,
                default: null
            },
            empresa_selecionada: {
                type: Object,
                default: null
            }
        },

        components: {
            Saudacao
        },


        computed: {
            exibe() {
                return true;
            },

            projetos() {
                return this.cliente.projetos;
            }
        },


        methods: {


            real (valor) {
                return this.$options.filters.dinheiro(valor);
            },
            // Isso precisa ser mudado, e rápido
            async plot()
            {
                if (! this.projetos.length) return '';

                return this.$refs.body.outerHTML

            }
        }
    }
</script>

<style lang="scss" scoped id="projetos-futuros-estilo">
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    margin-left: 120px;
    display: contents;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
th{
    text-align: center;
}
td{
    text-align: center;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
        margin-left: 25px;
        display: block;
    }
}
@media screen and (max-width: 600px) {
    table {
      border: 0;
    }

    table caption {
      font-size: 1.3em;
    }

    table thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    table tr {
      border-bottom: 3px solid #ddd;
      display: block;
      margin-bottom: .625em;
    }

    table td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: .8em;
      text-align: right;
    }

    table td::before {
      /*
      * aria-label has no advantage, it won't be read inside a table
      content: attr(aria-label);
      */
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--color-primary);
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/ProjetosFuturos.vue